import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TalentpoolService } from '../_services/talentpool.service';
import { PersonSearchService } from '../_services/person-search.service';
import { Observable, Subscription } from 'rxjs';
import * as _ from 'underscore';
import { LocalStorageService } from '../_services/local-storage.service';

@Component({
    selector: 'app-talentpool-suggested-candidate-list',
    templateUrl: './talentpool-suggested-candidate-list.component.html',
    styleUrls: ['./talentpool-suggested-candidate-list.component.scss'],
    standalone: false
})
export class TalentpoolRecommendedCandidateListComponent implements OnInit {

  @Input() talentpoolNumber: string = null;
  @Input() eventListener: Observable<any> = new Observable();
  @Output() eventEmitter: EventEmitter<any> = new EventEmitter();
  candidateListTotalCount: number = 0;
  candidateList: any[] = [];
  successMessage: string = '';
  errorMessage: string = '';
  candidatetoBeGrabbed: any[] = [];
  selected: boolean = false;
  eventListenerSubscription: Subscription = null;
  currentPage: number = 1;
  paginationStart: number = 0;
  pageSize: number = 10;
  currentCandidate: any = null;
  currentIndex: number = -1;
  showCandidate: boolean = false;
  viewMoreSkills: boolean = false;
  showLoaderbeforeDataLoad: boolean = false;
  isLoading: boolean = false;

  constructor(private talentpoolService: TalentpoolService, private personSearchService: PersonSearchService, private localStorageService: LocalStorageService) { }

  ngOnInit() {
    // listen to all events from parent
    this.eventListenerSubscription = this.eventListener.subscribe((event) => {
      this.combinedEventHandler(event)
    });

    // get page-size set as preference from local storage
    const preferenceArray = this.localStorageService.getItem('userdata')?.preferenceData;
    preferenceArray && preferenceArray.length && preferenceArray.map(item=>{
      if(item.listing_type == 'talentpool' && item.preference_type == 'page-size'){
        this.pageSize = item.preference_value;
      }
    })

    this.getTalentpoolSuggestedCandidates();
  }

  ngOnDestroy() {
    this.eventListenerSubscription && this.eventListenerSubscription.unsubscribe();
  }

  /**
   * Combined handler for all events received from parent
   * @param event 
   */
  combinedEventHandler(event: { action: string, data: any }) {    
    switch(event.action) {
      case 'REFRESH_CANDIDATE_LIST':
        this.getTalentpoolSuggestedCandidates();
        break;

      case 'PAGE_CHANGE':
        this.currentPage = event.data.page;
        this.paginationStart = event.data.start;
        this.pageSize = event.data.pageSize;
        this.getTalentpoolSuggestedCandidates();
        break;

      case 'BULK_SELECTION':
        const isSelectAll = event.data.value;
        this.selected = isSelectAll;
        this.candidateList.forEach((candidate) => {
          candidate.selected = isSelectAll;
          if(isSelectAll) {
            if(this.candidatetoBeGrabbed && this.candidatetoBeGrabbed.length < 100) {
              if(!this.candidatetoBeGrabbed.some(selectedCandidate => selectedCandidate.idinindex == candidate.idinindex)) {
                this.candidatetoBeGrabbed.push(candidate);
              }
            }
          } else {
            this.candidatetoBeGrabbed = [];
          }
        });
        this.eventEmitter.emit({ action: 'STATE_UPDATE', data: { type: 'CANDIDATE_SELECTED', talentpoolNumber: this.talentpoolNumber, candidate: this.candidatetoBeGrabbed } });
        break;

      case 'ALERT':
        if(event.data && event.data.type === 'SUCCESS') {
          const succeededCandidateIds = event.data.candidates;
          if(!(succeededCandidateIds && succeededCandidateIds.length)) return;
          this.candidateList = this.candidateList.filter((candidate) => !succeededCandidateIds.includes(candidate.idinindex));
          if(!this.candidateList.length) {
            this.getTalentpoolSuggestedCandidates();
          }

          this.candidateList.forEach((candidate) => {
            candidate.selected = false;
          });
          this.candidatetoBeGrabbed = [];
        }
        this.isLoading = false;
        break;
    }
  }

  /**
   * Get suggested candidates for talentpool
   */
  getTalentpoolSuggestedCandidates() {
    if(!this.talentpoolNumber) return;

    this.showLoaderbeforeDataLoad = true;
    this.talentpoolService.getTalentpoolSuggestedCandidates(this.talentpoolNumber, this.currentPage, this.pageSize).subscribe((res) => {
      if(res.status === 'success') {
        this.showLoaderbeforeDataLoad = false;
        this.candidateListTotalCount = res.data.totalResultsCount;
        this.candidateList = res.data.results.map((candidate) => ({ ...candidate, selected: false }));
      }
    },
    (err) => {
      this.candidateList = [];
      this.showLoaderbeforeDataLoad = false;
      if(err && err.status === 404) {
        this.eventEmitter.emit({ action: 'ALERT', data: { type: 'NO_DATA_FOUND' } });
      } else {
        console.log("[TalentpoolRecommendedCandidateListComponent] getTalentpoolSuggestedCandidates() error - ", err);
        this.setAlertMessage('failure');
      }
    })
  }

  /**
   * Handle success & error alert messages
   * @param type 
   * @param message 
   * @param timeout 
   */
  setAlertMessage(type: 'success' | 'failure' = 'success', message: string = '', timeout: number = 5000) {
    if(type === 'success') {
      this.successMessage = message || 'Success';
    } else {
      this.errorMessage = message || 'Something went wrong. Please try again later';
    }

    setTimeout(() => {
      this.successMessage = '';
      this.errorMessage = '';
    }, timeout);
  }

  /**
   * Handle candidate selection
   * @param e 
   * @param data 
   */
  selectCandidate(e: Event, data: any) {
    if (e && (e.target as HTMLInputElement) && (e.target as HTMLInputElement).checked) {
      if (this.candidatetoBeGrabbed && this.candidatetoBeGrabbed.length < 100) {
        if (this.candidatetoBeGrabbed && this.candidatetoBeGrabbed.length) {
          if (!this.candidatetoBeGrabbed.some(candidate => candidate.idinindex == data.idinindex)) {
            this.candidatetoBeGrabbed.push(data)
          }
        } else {
          this.candidatetoBeGrabbed.push(data)
        }
        data.selected = true
        if (this.candidateList && this.candidatetoBeGrabbed && (this.candidateList.length == this.candidatetoBeGrabbed.length)) {
          this.selected = true;
        }
      } else {
        data.selected = false;
        (e.target as HTMLInputElement).checked = false;
      }
    } else {
      this.selected = false;
      data.selected = false;
      (e.target as HTMLInputElement).checked = false;
      this.candidatetoBeGrabbed = this.candidatetoBeGrabbed.filter(x => x['idinindex'] != data.idinindex)
    }

    this.eventEmitter.next({ action: 'STATE_UPDATE', data: { type: 'CANDIDATE_SELECTED', talentpoolNumber: this.talentpoolNumber, candidate: this.candidatetoBeGrabbed } });
  }

  /**
   * Handler for refresh event from candidate card
   * @param $event 
   */
  refreshCurrentView($event: any) {
    const elastic_id = $event && $event.id ? $event.id : null
    if (elastic_id != null) {
      this.getLastActivity(elastic_id)
    }
  }

  /**
   * Update last activity against profile
   * @param elastic_id 
   */
  getLastActivity(elastic_id: string) {
    if (elastic_id && Array.isArray(elastic_id) && elastic_id.length) {
      elastic_id = elastic_id[0]
    }

    let currentIndex = this.candidateList.findIndex(x => x.idinindex === elastic_id)
    this.personSearchService.getLastCandidateActivity(elastic_id).subscribe((result: any) => {
      if (result && result.status == 'success') {
        this.candidateList[currentIndex]['lastcandidateactivity'] = result.message
      }
    });
  }

  /**
   * Reset pagination to first page by emitting event to parent component
   */
  resetPagination() {
    this.eventEmitter.next({ action: 'PAGINATION_RESET', data: { page: 1, start: 0 } });
  }

  /**
   * Emit event to parent component to add candidate to talentpool
   * @param candidateData 
   */
  moveToTalentpool(candidateData: any) {
    if(!this.talentpoolNumber) return;

    this.eventEmitter.emit({ action: 'ADD_TO_TALENTPOOL', data: { talentpoolNumber: this.talentpoolNumber, candidate: [candidateData] } });
    this.isLoading = true;
    return this.closeNav();
  }

  /**
  * Handles child events and accordingly calls specified function
  * @param event childevent
  */
  eventHandler(event: any) {
    if (event.action == 'openNav') {
      if (event.data && event.data.experience && event.data.experience.length) {
        const companyObjects = event.data.experience.map(((a: any) => a.company));
       
        const companyLogoPayload = companyObjects.map(obj => {
          if (obj?.id || obj?.name) {
            return {
              ...(obj?.id && { id: obj.id }),
              ...(obj?.name && { name: obj.name })
            }
          }
        }).filter(Boolean);

        companyLogoPayload.length && 
        this.personSearchService.getCompanyLogoV2(companyLogoPayload).subscribe((res: any) => {
          if (res && res.status == "success") {
            const resultName = res.data
            resultName.forEach(obj => {
              const matchingObj = event.data.experience.filter((item) => ((obj.searchedVia === 'id' && obj.key === item.company.id) || (obj.searchedVia === 'name' && obj.key === item.company.name)));
              
              if (matchingObj && matchingObj.length) {
                let companyLogo = obj.companylogo
                matchingObj.forEach(x => {
                  x.companylogo = companyLogo;
                })

              }
            });

            this.openCandidateSlider(event.data, event.currentIndex)
          } else {
            this.openCandidateSlider(event.data, event.currentIndex)
          }
        });
      } else {
        this.openCandidateSlider(event.data, event.currentIndex)
      }
    } else if (event.action == 'closeNav') {
      this.closeNav();
    }

    this.getLastActivity(event.data.idinindex)
  }

  /**
   * Open candidate slider
   * @param data 
   * @param currentIndex 
   */
  openCandidateSlider(data: any, currentIndex: number) {
    this.currentCandidate = data;
    this.currentIndex = currentIndex
    this.showCandidate = true;
    document.getElementById("quickView").style.width = "55%";
    document.getElementById("quickView").style.right = "0";
    document.getElementById("overlay").style.display = "block";
  }

  /**
   * Close slider
   */
  closeNav() {
    this.viewMoreSkills = false;
    this.showCandidate = false
    document.getElementById("quickView").style.width = "0";
    document.getElementById("overlay").style.display = "none";
    document.getElementById("quickView").style.right = "-50px";
  }
}
